var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"py-3"},_vm._l((_vm.questions),function(q,idx){return _c('CheckBoxQuestion',{key:idx,staticClass:"mb-3",attrs:{"description":q.description,"question":q.question,"value":q.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }